<div class="collapse-container">
    <div
        class="collapse-header"
        tabindex="0"
        role="button"
        [attr.aria-expanded]="isOpen"
        [attr.aria-controls]="contentId"
        [attr.aria-label]="
            panel.title + ' toggle. ' + (isOpen ? 'Expanded' : 'Collapsed')
        "
        [attr.id]="headerId"
        (click)="toggle()"
        (keydown)="onKeydown($event)"
    >
        {{ panel.title }}
        <span class="collapse-icon" aria-hidden="true">
            {{ isOpen ? '-' : '+' }}
        </span>
    </div>
  
    <div
        *ngIf="isOpen"
        class="collapse-content"
        [attr.id]="contentId"
        role="region"
        [attr.aria-labelledby]="headerId"
    >
        <p [innerHTML]="panel.answer"></p>
    </div>

    <!-- for screen readers -->
    <p *ngIf="!isOpen" class="visually-hidden" aria-live="polite">
        Collapsed.
    </p>
</div>
